/**
 * Run detail / replay route (Screen 3, FM-157) — eager stub. The replay view +
 * its atoms are deferred to `$runId.lazy.tsx`.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/flirtmachine/_authenticated/admin/simulator/$runId")({});
